import React, { Fragment } from "react";
import { Button } from "@components";
import type { ConfirmModals } from "./types";

const SubmissionModal = (props: ConfirmModals) => (
  <Fragment>
    {props.t("SUBMISSION_WARNING")}
    <div className="d-flex justify-content-center pt-5">
      <Button className="w-25 mr-5" onClick={props.onCancel}>
        {props.t("NO")}
      </Button>
      <Button className="w-25" onClick={props.onSubmit}>
        {props.t("YES")}
      </Button>
    </div>
  </Fragment>
);

export default SubmissionModal;
